// extracted by mini-css-extract-plugin
export default {"noticeArea":"NoticeForm_noticeArea__oMh3c","title":"NoticeForm_title__8B4ea","content":"NoticeForm_content__tXs0D"};